import { Link, generatePath } from 'react-router';
import { highlightKeyword } from '../../common/utils/searchFieldUtils.js';
import { getSubscriptionUrlId } from '../../common/utils/subscriptionUtils.js';
import { SubscriptionIcon } from './SubscriptionIcon.js';
import type { SubscriptionHeader } from '../../generated/api/models.js';
import type { ReactNode } from 'react';

interface SubscriptionLinkProps {
  path: string;
  subscription: SubscriptionHeader;
  children?: ReactNode;
  search?: string;
  withoutIcon?: boolean;
  disabled?: boolean;
}
export const SubscriptionLink = ({
  children,
  path,
  subscription,
  search,
  withoutIcon = false,
  disabled = false,
}: SubscriptionLinkProps) => {
  if (!subscription.accountMasterId) {
    throw new Error('missing mdmId');
  }
  const content = (
    <>
      {!withoutIcon && <SubscriptionIcon subscription={subscription} />}
      <div>
        {highlightKeyword(subscription.subscriptionName || '', search)}
        {children}
      </div>
    </>
  );

  return disabled ? (
    <div className="of-subscription-table__text-column">{content}</div>
  ) : (
    <Link
      to={`${generatePath(path, { subscriptionId: getSubscriptionUrlId(subscription) })}?mdmId=${subscription.accountMasterId}`}
      className="of-subscription-table__text-column"
    >
      {content}
    </Link>
  );
};
